export function externalClientLabel(client?: string | null): string {
  if (client === 'codex') return 'Codex';
  if (client === 'claude_code') return 'Claude Code';
  if (client === 'other') return 'External client';
  return client?.trim() || 'External worker';
}
